import React, { Component } from "react";
import * as auth from "../../store/ducks/auth.duck";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";
import { logoutUser } from "../../crud/auth.crud";

class Logout extends Component {
  async componentDidMount() {
    await logoutUser();   // server: token no longer valid (v2 logs out on its next request)
    this.props.logout();  // browser: clear v1's session, as before
  }

  render() {
    const { hasAuthToken } = this.props;

    return hasAuthToken ? <LayoutSplashScreen /> : <Redirect to="/auth" />;
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions
)(Logout);
